import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'


import './styles.less'

class Day extends React.Component {
	shouldComponentUpdate(nextProps) {
		if (nextProps.active !== this.props.active) {
			return true
		}
		if (nextProps.timestamp !== this.props.timestamp) {
			return true
		}

		if (nextProps.desc !== this.props.desc) {
			if (typeof nextProps.desc !== 'undefined') {
				return true
			}
		}

		return false
	}

	componentWillUpdate() {
		// console.log('day update '+this.props.timestamp )
	}

	componentWillMount() {
	
	}

	onSelect(e){
		if (this.props.active) { return }
		this.props.onSelect(this.props.timestamp, e.target)
	}
	onTouchStart(e){
		if (this.props.active) { return }
		this.props.onSelect(this.props.timestamp, e.target)
	}

	render() {
		let active   = this.props.active   ? 'active':''
		let disabled = this.props.disabled ? 'disabled':''

		const day = moment.unix(this.props.timestamp)
		const desc = this.props.desc ? this.props.desc : ' . . . '
		const descClass = desc ? 'show' : 'hide'
		
		return (
			<div 
				className={`day ${active} ${disabled}`}
				onClick={this.onSelect.bind(this)} 
			>
				<sup>{day.format('dd')}</sup>
				<b>{day.format('D')}</b>
				<u className={`${descClass}`}>{desc}</u>
			</div>
		)
	}
}

Day.propTypes = {
	timestamp: PropTypes.number.isRequired,
	onSelect:  PropTypes.func,
	active:    PropTypes.bool,
	disabled:  PropTypes.bool,
	desc:      PropTypes.string
}

export default Day


// WEBPACK FOOTER //
// ./src/components/DaySelector/Day/index.js